// extracted by mini-css-extract-plugin
export default {"loader":"SelectCode_loader__36Hu4","notFound":"SelectCode_notFound__ZIQph"};